import { render, staticRenderFns } from "./DriverProcess.vue?vue&type=template&id=5b2c1940&"
import script from "./DriverProcess.vue?vue&type=script&lang=js&"
export * from "./DriverProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports